import React from "react";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Services from "./components/Services";
import About from "./components/About";
import Footer from "./components/Footer";
import FormCotacao from "./components/FormCotacao";
import WhatsAppContact from "./components/WhatsAppContact";
import ContactSection from './components/ContactSection';


function App() {
  return (
    <>
     <WhatsAppContact/>
      <Header />
      <Banner />
      <section id="contact">
      <FormCotacao />
      </section>
      <Services/>
      <About />
      <ContactSection />
      <Footer />
    </>
  );
}

export default App;
